import React from 'react';

type SectionHeaderProps = {
    title: string;
    /** Optional control shown opposite the title, e.g. the contest section's share button. */
    action?: React.ReactNode;
    /** Optional muted line directly under the title, e.g. the gallery's image credits. */
    subtitle?: string;
};

const SectionHeader = ({ title, action, subtitle }: SectionHeaderProps) => {
    return (
        <div className="flex flex-row items-center justify-between space-x-[6px] mb-[24px]">
            <div className="flex flex-col gap-4 text-center lg:text-left">
                <h2 className="text-headline-20 lg:text-headline-24">{title}</h2>
                {subtitle && <p className="text-body-12 opacity-50">{subtitle}</p>}
            </div>
            {action && <div className="shrink-0">{action}</div>}
        </div>
    );
};

export default SectionHeader;
